// UserContect.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { getToken } from '../utils/auth';

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(`${process.env.REACT_APP_URL}/api/user`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUserData(response?.data?.data);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const updateUserProfile = (updatedUserData) => {
    setUserData(updatedUserData);
  };

  return (
    <UserContext.Provider value={{ userData, loading, fetchUserData, updateUserProfile }}>
      {children}
    </UserContext.Provider>
  );
};
